export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_NUMBER = 1;
export const PAGE_SIZE_OPTIONS = [
  {
    title: '10',
    value: '10',
  },
  {
    title: '20',
    value: '20',
  },
  {
    title: '30',
    value: '30',
  },
  {
    title: '50',
    value: '50',
  },
  {
    title: '100',
    value: '100',
  },
];
